// extracted by mini-css-extract-plugin
module.exports = {"container":"_31zzaXN","basket":"_3-NsbuV","counter":"p-k6exp"};